export class ShowSpinner {
  static readonly type = '[UI] Show Spinner';
}​
